module.exports = "https://r.nearpod.com/assets/media/image/handPlant-ae1236f41e14db22143f9f89a7b22f41.svg";